import pic from '../Assets/login.jpg'

const logininput = {
    image:[
        {
            id:1,
            image:pic,
            field: 'login_image',
        }
    ],
   login: [
    {
        id: 1,
        field: 'phone_or_email',
        name: 'Enter your phone or email',
        type: 'text',
        isrequired: true,
        otp_show: true   // OTP allowed
    },
    {
        id: 2,
        field: 'password',
        name: 'Enter your password',
        type: 'password',
        isrequired: false,   // password optional
        is_show: true,
        otp_show: false      // password login
    },
    {
        id: 3,
        field: 'otp',
        name: 'Enter OTP',
        type: 'otp',
        isrequired: true,
        digits: 6,
        _show: true 
    }
],

    signup: [
        {
            id: 1,
            field: 'name',
            name: 'Enter your name',
            type: 'text',
            isrequired: true
        },
        {
            id: 2,
            field: 'phone',
            name: 'Enter your phone',
            type: 'number',
            isrequired: true,
            is_show: true,
            otp_show: false,
            otppin:123456
        },
        {
            id: 3,
            field: 'email',
            name: 'Enter your email',
            type: 'email',
            isrequired: true,
            is_show: true,
            otp_show: false,
            otppin:654321
        },
        {
            id: 4,
            field: 'otp',
            time:2,
            name: 'Enter OTP',
            type: 'otp',
            isrequired: true,
            digits: 6
        },
        {
            id: 5,
            field: 'password',
            name: 'Enter your password',
            type: 'password',
            isrequired: true,
            is_show: true
        },
        {
            id: 6,
            field: 'confirm_password',
            name: 'Confirm your password',
            type: 'password',
            isrequired: true,
            is_show: true
        }
    ],

    forgot_password: [
        {
            id: 1,
            field: 'phone',
            name: 'Enter your phone',
            type: 'text',
            is_show: true,
            isrequired: true,
            otp_show: true
        },
        {
            id: 2,
            field: 'email',
            name: 'Enter your email',
            type: 'email',
            is_show: true,
            otp_show: true,
            isrequired: true
        },
        {
            id: 3,
            field: 'otp',
            time:2,
            name: 'Enter OTP',
            type: 'otp',
            isrequired: true,
            digits: 6
        }
    ],

    reset_password: [
        {
            id: 1,
            field: 'new_password',
            name: 'Enter new password',
            type: 'password',
            isrequired: true,
            is_show: true
        },
        {
            id: 2,
            field: 'confirm_password',
            name: 'Confirm new password',
            type: 'password',
            isrequired: true,
            is_show: true
        }
    ]
};

export default logininput;